import Component from 'D:/小小程序员/项目/medical-management/OPO-uni/uni_modules/uview-plus/components/u-status-bar/u-status-bar.vue'
wx.createComponent(Component)